import request from '@/utils/request'
import type { UserListResponse } from '@/types/UserListResponse'
import type { PageParams } from '@/types/PageParams'
import type { User } from '@/types/User'
import type { Role } from '@/types/Role'
import type { ApiResponse } from '@/types/ApiResponse'

// 新增用户请求体：仅用户名、密码必填，status 使用整型（1 正常 / 0 禁用）
export interface CreateUserPayload {
  username: string
  password: string
  email?: string
  phone?: string
  status?: number
  departmentId?: number
}

// 编辑用户请求体：所有字段均为可选，status 使用整型（1 正常 / 0 禁用）
export interface UpdateUserPayload {
  username?: string
  email?: string
  phone?: string
  status?: number
  departmentId?: number
}

export const userApi = {
  // 获取当前登录用户信息（含 roles + permissions），用于前端鉴权与用户态恢复
  getCurrentUser(): Promise<ApiResponse<User>> {
    return request.get('/admin/api/v1/users/me')
  },

  // Get user list with pagination
  getUserList(params: PageParams): Promise<UserListResponse> {
    return request.get('/admin/api/v1/users', { params })
  },

  // Get user by id
  getUserById(id: number): Promise<ApiResponse<User>> {
    return request.get(`/admin/api/v1/users/${id}`)
  },

  // Create user
  createUser(user: CreateUserPayload): Promise<ApiResponse<User>> {
    return request.post('/admin/api/v1/users', user)
  },

  // Update user
  updateUser(id: number, user: UpdateUserPayload): Promise<ApiResponse<User>> {
    return request.put(`/admin/api/v1/users/${id}`, user)
  },

  // Delete user
  deleteUser(id: number): Promise<ApiResponse> {
    return request.delete(`/admin/api/v1/users/${id}`)
  },

  // 查询用户当前已分配的角色（用于分配角色弹窗回显）
  getUserRoles(id: number): Promise<ApiResponse<Role[]>> {
    return request.get(`/admin/api/v1/users/${id}/roles`)
  },

  // 全量覆盖式分配角色：传入选中的角色 ID 列表，空数组表示清空
  assignRolesToUser(id: number, roleIds: number[]): Promise<ApiResponse<void>> {
    return request.post(`/admin/api/v1/users/${id}/roles`, roleIds)
  },
}